// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3h5rI","modalForm":"UpgradeEpcsModal_modalForm__2IbIl","modalFooter":"UpgradeEpcsModal_modalFooter__1DA99"};